import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-6">
          <i className="ri-emotion-sad-line text-3xl"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-900">页面找不到了</h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">您访问的页面可能已被移除或暂时不可用</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}